import Orders from './Orders.view';

export default Orders;
